import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=5609a61c&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=5609a61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609a61c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5609a61c')) {
      api.createRecord('5609a61c', component.options)
    } else {
      api.reload('5609a61c', component.options)
    }
    module.hot.accept("./VideoPlayer.vue?vue&type=template&id=5609a61c&scoped=true&", function () {
      api.rerender('5609a61c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VideoPlayer.vue"
export default component.exports